import { throwValidationError } from "../errors.lib";
import { EMAIL_FORMAT } from "../../shared/formats/email";

export function isValidEmail(email: string): boolean {
  return EMAIL_FORMAT.validate(email);
}

export function validateEmail(email: string, fieldName = "email"): void {
  if (!isValidEmail(email)) {
    throwValidationError(`${fieldName}: ${EMAIL_FORMAT.errorMessage}`);
  }
}
